import React from 'react';
import { Chart } from 'react-chartjs-2';
import { type ChartData } from 'chart.js';
import { type AggregatedMetrics } from '@prerender/prerender-shared/FE';

import { numberFormatter } from '~library/numbers';
import { getXAxisConfig } from '../Chart';
import { useIsPrinting } from '~library/print';

export const MAIN_CHART_ID = 'average-crawl-time-main-chart';

type AverageCrawlTimeMainChartProps = {
  labels: string[];
  datasets: ChartData<'bar', number[], string>['datasets'];
  granularity: AggregatedMetrics.IntervalGranularity;
};
function AverageCrawlTimeMainChart({ labels, datasets, granularity }: AverageCrawlTimeMainChartProps) {
  const { isPrinting } = useIsPrinting();
  return (
    <Chart
      id={MAIN_CHART_ID}
      type="bar"
      data={{ labels, datasets }}
      options={{
        animation: isPrinting ? false : undefined,
        scales: {
          x: getXAxisConfig(granularity),
          y: {
            type: 'linear',
            ticks: {
              count: 5,
              callback: (value) => `${numberFormatter.format(Number(value) / 1000)}s`,
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) =>
                `${context.dataset.label}: ${numberFormatter.format(Number(context.parsed.y) / 1000)}s`,
            },
          },
        },
      }}
    />
  );
}

export default AverageCrawlTimeMainChart;
